import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'dtis-loading-bar',
  imports: [CommonModule],
  template: `
    @if (loading()) {
    <div
      class="bg-primary animate-progress origin-left-right h-1 w-full"
      [ngStyle]="{ backgroundColor: backgroundColor() }"
    ></div>
    }
  `,
  host: {
    class: 'flex h-1 w-full  overflow-hidden',
  },
})
export class DtisLoadingBarComponent {
  /**
   *
   */
  loadingState = false;
  /**
   *
   */
  loading = input<boolean | null>(false);
  /**
   * any tailwind color or hexcode
   */
  backgroundColor = input<string>('primary');
}
